import React, { useEffect, useMemo, useRef, useState } from "react";
// import Rajneeti1 from "../../videos/Rajneeti/Rajneeti1.mp4"; // ✅ replace with Media page hero video if needed
import { NavLink as RouterLink } from "react-router-dom";
import ContactA4H from "../Contact/ContactA4H";
import Proclamation1 from "../../images/proclamations/proclamation1.jpg";
import Proclamation2 from "../../images/proclamations/proclamation2.jpg";
import Proclamation3 from "../../images/proclamations/proclamation3.jpg";
import Proclamation4 from "../../images/proclamations/proclamation4.jpg";
import Proclamation5 from "../../images/proclamations/proclamation5.jpg";
import Proclamation6 from "../../images/proclamations/proclamation6.jpg";
import Proclamation7 from "../../images/proclamations/proclamation7.jpg";
import Proclamation8 from "../../images/proclamations/proclamation8.jpg";
import Proclamation9 from "../../images/proclamations/proclamation9.jpg";
import PressImg01 from "../../images/press-releases/press-01.jpg";
import PressImg02 from "../../images/press-releases/press-02.jpg";
import PressImg03 from "../../images/press-releases/press-03.jpg";
import PressImg04 from "../../images/press-releases/press-04.jpg";
import PressImg05 from "../../images/press-releases/press-05.jpg";
import PressImg06 from "../../images/press-releases/press-06.jpg";
import PressImg07 from "../../images/press-releases/press-07.jpg";
import PressImg08 from "../../images/press-releases/press-08.jpg";
import PressImg09 from "../../images/press-releases/press-09.jpg";
import PressImg10 from "../../images/press-releases/press-10.jpg";
import PressImg11 from "../../images/press-releases/press-11.jpg";
import PressImg12 from "../../images/press-releases/press-12.jpg";
import PressImg13 from "../../images/press-releases/press-13.jpg";
import PressImg14 from "../../images/press-releases/press-14.jpg";
import PressImg15 from "../../images/press-releases/press-15.jpg";
import PressImg16 from "../../images/press-releases/press-16.jpg";
import PressImg17 from "../../images/press-releases/press-17.jpg";
import PressImg18 from "../../images/press-releases/press-18.jpg";
import PressImg19 from "../../images/press-releases/press-19.jpg";
import PressImg20 from "../../images/press-releases/press-20.jpg";
import AndrewFriedson from "../../images/press-releases/Andrew Friedson.jpg";
import GregoryMeeks from "../../images/press-releases/Gregory W Meeks.jpg";
import AshokBaddi from "../../images/press-releases/Ashok Baddi.jpg";
import BridgetWatson from "../../images/press-releases/Bridget Watson.jpg";
import DrAnilKumar from "../../images/press-releases/Dr Anil Kumar.jpg";
import DrPrabuSelvam from "../../images/press-releases/Dr Prabu Selvam.jpg";
import HonLien from "../../images/press-releases/Hon Lien.jpg";
import IlanitEliaz from "../../images/press-releases/Ilanit Eliaz.jpg";
import ManishaPathak from "../../images/press-releases/Manisha Pathak.jpg";
import MichaelGates from "../../images/press-releases/Michael Gates.jpg";
import RakeshRamakrishnan from "../../images/press-releases/Rakesh Ramakrishnan.jpg";
import RodVilhauer from "../../images/press-releases/Rod Vilhauer.jpg";
import SantoshRao from "../../images/press-releases/Santosh Rao.jpg";
import SeemaKanani from "../../images/press-releases/seema kanani.jpg";
import SenatorMichaelWebber from "../../images/press-releases/Senator Michael Webber.jpg";
import ShriThanedar from "../../images/press-releases/Shri Thanedar .jpg";
import SteveHilton from "../../images/press-releases/Steve Hilton.jpg";
import TomKuhn from "../../images/press-releases/Tom Kuhn.jpg";

import JenneAlderks from "../../images/press-releases/Jenne Alderks.jpg";


function MediaCarousel({ items = [], ariaLabel = "carousel" }) {
  const [index, setIndex] = useState(0);
  const touchRef = useRef({ x: 0, y: 0, active: false });
  const [isOpen, setIsOpen] = useState(false);

  const safeItems = Array.isArray(items) ? items : [];
  const active = safeItems[index] || null;

  const goPrev = () => setIndex((i) => (safeItems.length ? (i - 1 + safeItems.length) % safeItems.length : 0));
  const goNext = () => setIndex((i) => (safeItems.length ? (i + 1) % safeItems.length : 0));

  const onTouchStart = (e) => {
    const t = e.touches?.[0];
    if (!t) return;
    touchRef.current = { x: t.clientX, y: t.clientY, active: true };
  };

  const onTouchMove = (e) => {
    // allow natural scrolling if vertical gesture
    const t = e.touches?.[0];
    if (!t || !touchRef.current.active) return;
    const dx = Math.abs(t.clientX - touchRef.current.x);
    const dy = Math.abs(t.clientY - touchRef.current.y);
    if (dy > dx) touchRef.current.active = false;
  };

  const onTouchEnd = (e) => {
    const t = e.changedTouches?.[0];
    if (!t) return;
    const { x, active } = touchRef.current;
    if (!active) return;

    const deltaX = t.clientX - x;
    const threshold = 35;

    if (deltaX > threshold) goPrev();
    if (deltaX < -threshold) goNext();

    touchRef.current.active = false;
  };

  if (!safeItems.length) {
    return (
      <div className="fog-mediaCarousel fog-mediaCarousel--empty" role="region" aria-label={ariaLabel}>
        <p className="white" style={{ margin: 0 }}>
          No items available yet.
        </p>
      </div>
    );
  }

  return (
    <div
      className="fog-mediaCarousel"
      role="region"
      aria-label={ariaLabel}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <button type="button" className="fog-carouselBtn fog-carouselBtn--left" onClick={goPrev} aria-label="Previous">
        ‹
      </button>
          {isOpen && (
      <div className="fog-modalOverlay" onClick={() => setIsOpen(false)}>
        <div className="fog-modalContent" onClick={(e) => e.stopPropagation()}>
          <button
            className="fog-modalClose"
            onClick={() => setIsOpen(false)}
            aria-label="Close"
          >
            ×
          </button>
          <img src={active.image} alt={active.title || "media"} />
        </div>
      </div>
    )}


      <div className="fog-carouselSlide">
        {/* image slide */}
        <div className="fog-carouselImageWrap">
          <img className="fog-carouselImage" src={active.image} alt={active.title || "slide"} />
        </div>

        {/* caption + optional open link */}
        <div className="fog-carouselCaption">
          <h4 className="white fog-carouselTitle">{active.title}</h4>
          {active.subtitle ? <p className="white fog-carouselSub">{active.subtitle}</p> : null}

          {active.href ? (
            <button
              type="button"
              className="fog-btn fog-btn--small"
              onClick={() => setIsOpen(true)}
            >
              Open
            </button>

          ) : null}

          <div className="fog-carouselDots" aria-label="slide indicators">
            {safeItems.map((_, i) => (
              <button
                key={i}
                type="button"
                className={`fog-dot ${i === index ? "is-active" : ""}`}
                onClick={() => setIndex(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <button type="button" className="fog-carouselBtn fog-carouselBtn--right" onClick={goNext} aria-label="Next">
        ›
      </button>
    </div>
  );
}

function FogMediaPage() {
  /* ✅ VIDEO controls (same pattern as your Events page) */
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const topVideoRef = useRef(null);

  useEffect(() => {
    const v = topVideoRef.current;
    if (!v) return;

    v.muted = true;

    const playPromise = v.play();
    if (playPromise && typeof playPromise.then === "function") {
      playPromise.then(() => setIsPlaying(true)).catch(() => setIsPlaying(false));
    } else {
      setIsPlaying(!v.paused);
    }
  }, []);

  useEffect(() => {
    const v = topVideoRef.current;
    if (v) v.muted = isMuted;
  }, [isMuted]);

  const togglePlayPause = async () => {
    const v = topVideoRef.current;
    if (!v) return;

    if (v.paused) {
      try {
        await v.play();
        setIsPlaying(true);
      } catch {
        setIsPlaying(false);
      }
    } else {
      v.pause();
      setIsPlaying(false);
    }
  };

  const toggleMute = () => setIsMuted((m) => !m);

  /* ✅ Data placeholders (replace with real files/urls) */
  
  const pressReleases = useMemo(
    () => [
      { title: "Vivek Ramaswamy",  image: PressImg01, href: PressImg01 },
      { title: "Mike Lawler",  image: PressImg02, href: PressImg02 },
      { title: "Senator Jim risch",  image: PressImg03, href: PressImg03 },
      { title: "Ethan Agarawal",  image: PressImg04, href: PressImg04 },
      { title: "Jason Miyares",  image: PressImg05, href: PressImg05 },
      { title: "Neil Khot",  image: PressImg06, href: PressImg06 },
      { title: "Bruce Leon",  image: PressImg07, href: PressImg07 },
      { title: "Randy Fine",  image: PressImg08, href: PressImg08 },
      { title: "Jimmy Patronis",  image: PressImg09, href: PressImg09 },
      { title: "Vin Kruttiventi", image: PressImg10, href: PressImg10 },
      { title: "Haley Stevens", image: PressImg11, href: PressImg11 },
      { title: "Jag Nagendra", image: PressImg12, href: PressImg12 },
      { title: "Chinmay Nagarkar", image: PressImg13, href: PressImg13 },
      { title: "For Hon. Theresa Rich", image: PressImg14, href: PressImg14 },
      { title: "Aditya Ahlawat", image: PressImg15, href: PressImg15 },
      { title: "Bruce Leon", image: PressImg16, href: PressImg16 },
      { title: "Neil Khot", image: PressImg17, href: PressImg17 },
      { title: "Ethan Agarwal", image: PressImg18, href: PressImg18 },
      { title: "Jason Miyares", image: PressImg19, href: PressImg19 },
      { title: "Geary Higgins", image: PressImg20, href: PressImg20 },
      { title: "Andrew Friedson", image: AndrewFriedson, href: AndrewFriedson },
      { title: "Ashok Baddi", image: AshokBaddi, href: AshokBaddi },
      { title: "Bridget Watson", image: BridgetWatson, href: BridgetWatson },
      { title: "Dr. Anil Kumar", image: DrAnilKumar, href: DrAnilKumar },
      { title: "Dr. Prabu Selvam", image: DrPrabuSelvam, href: DrPrabuSelvam },
      { title: "Hon Lien", image: HonLien, href: HonLien },
    { title: "Ilanit Eliaz", image: IlanitEliaz, href: IlanitEliaz },
    { title: "Manisha Pathak", image: ManishaPathak, href: ManishaPathak },
    { title: "Michael Gates", image: MichaelGates, href: MichaelGates },
    { title: "Rakesh Ramakrishnan", image: RakeshRamakrishnan, href: RakeshRamakrishnan },
    { title: "Rod Vilhauer", image: RodVilhauer, href: RodVilhauer },
    { title: "Santosh Rao", image: SantoshRao, href: SantoshRao },
    { title: "Seema Kanani", image: SeemaKanani, href: SeemaKanani },
    { title: "Senator Michael Webber", image: SenatorMichaelWebber, href: SenatorMichaelWebber },
    { title: "Shri Thanedar", image: ShriThanedar, href: ShriThanedar },
    { title: "Steve Hilton", image: SteveHilton, href: SteveHilton },
    { title: "Tom Kuhn", image: TomKuhn, href: TomKuhn },
    { title: "Jenne Alderks", image: JenneAlderks, href: JenneAlderks },
    { title: "Gregory W. Meeks", image: GregoryMeeks },
    ],
    []
  );


  const proclamations = useMemo(
    () => [
      {
        title: "CITY OF MILPITAS",
        image: Proclamation1,
        href: Proclamation1, // opens full image
      },
      {
        title: "17th CONGRESSIONAL DISTRICT OF CALIFORNIA",
        image: Proclamation2,
        href: Proclamation2,
      },
      {
        title: "CITY OF FREMONT",
        image: Proclamation3,
        href: Proclamation3,
      },
      {
        title: "THE CITY OF SUNNYVALE CALIFORNIA",
        image: Proclamation4,
        href: Proclamation4,
      },
      {
        title: "CITY OF MILPITAS",
        image: Proclamation5,
        href: Proclamation5,
      },
      {
        title: "FOG PROCLAMATIONS",
        image: Proclamation6,
        href: Proclamation6,
      },
      {
        title: "FOG PROCLAMATIONS",
        image: Proclamation7,
        href: Proclamation7,
      },
      {
        title: "FOG PROCLAMATIONS",
        image: Proclamation8,
        href: Proclamation8,
      },
      {
        title: "FOG PROCLAMATIONS",
        image: Proclamation9,
        href: Proclamation9,
      },
    ],
    []
  );


  return (
    <>
      <style>{`
        html, body { overflow-x: hidden; }
        .mt-4 { margin-top: 1.5rem !important; }
        .mt-3 { margin-top: 1rem !important; }

        /* ===== Buttons (same as your Events page) ===== */
        .fog-action-buttons {
          display: flex;
          gap: 1.25rem;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 2.5rem;
        }
        .fog-btn {
          position: relative;
          padding: 14px 34px;
          font-size: 16px;
          font-weight: 700;
          letter-spacing: 0.8px;
          text-transform: uppercase;
          border-radius: 50px;
          border: 2px solid transparent;
          background: linear-gradient(135deg, #ff9933, #ff6600);
          color: #ffffff;
          cursor: pointer;
          transition: all 0.35s ease;
          text-decoration: none;
          box-shadow: 0 10px 25px rgba(255, 153, 51, 0.35);
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .fog-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 15px 35px rgba(255, 153, 51, 0.5);
        }
        .fog-btn.secondary:hover {
          background: #ffffff;
          color: #000000;
          box-shadow: 0 12px 30px rgba(255, 255, 255, 0.35);
        }
        .fog-btn:active { transform: translateY(-1px); }
        .fog-btn--small { padding: 10px 18px; font-size: 13px; letter-spacing: .6px; }

        /* ===== Video section (same pattern) ===== */
        .fog-fullVideo{
          width:100vw; max-width:100vw; margin:0; padding:0; position:relative;
          left:50%; right:50%; margin-left:-50vw; margin-right:-50vw;
          background:#000; overflow:visible; height:auto;
        }
        .fog-fullVideo video{ width:100%; height:auto; object-fit:contain; display:block; background:#000; }
        .fog-videoControls{ position:absolute; top:auto; right:auto; bottom:16px; left:16px; display:flex; gap:10px; z-index:3; }
        .fog-ctrlBtn{
          border:1px solid rgba(255,255,255,.22); background:rgba(0,0,0,.45); color:#fff;
          border-radius:999px; padding:10px 14px; font-size:13px; letter-spacing:.02em;
          backdrop-filter:blur(10px); cursor:pointer; white-space:nowrap;
        }
        .fog-ctrlBtn:hover{ background:rgba(0,0,0,.6); }
        @media (max-width: 768px){ .fog-videoControls{ bottom:6px; left:6px; gap:4px; } .fog-ctrlBtn{ min-width:42px; height:22px; padding:0 6px; border-radius:6px; font-size:8px; line-height:1.1; font-weight:700; letter-spacing:0; background:rgba(10,14,22,0.74); box-shadow:0 2px 8px rgba(0,0,0,0.28); } }

        /* ===== Heading styles (match your HRA style usage) ===== */
        .hra-topTitle{
          margin:0;
          line-height:1.1;
          font-size:clamp(28px,4vw,44px);
          font-weight:800;
          letter-spacing:0.01em;
          text-align:center;
        }
        .hra-topIntro{
          margin:10px auto 0;
          max-width:860px;
          opacity:.96;
          font-size:16px;
          line-height:1.55;
          text-align:center;
        }

        /* ===== Carousel (swipe + buttons) ===== */
        .fog-mediaCarousel{
          position:relative;
          width:100%;
          border-radius:18px;
          overflow:hidden;
          background:rgba(255,255,255,.06);
          border:1px solid rgba(255,255,255,.12);
        }
        .fog-mediaCarousel--empty{
          padding:18px;
          text-align:center;
        }
        .fog-carouselBtn{
          position:absolute;
          top:50%;
          transform:translateY(-50%);
          z-index:4;
          width:44px;
          height:44px;
          border-radius:999px;
          border:1px solid rgba(255,255,255,.22);
          background:rgba(0,0,0,.45);
          color:#fff;
          font-size:28px;
          line-height:1;
          display:grid;
          place-items:center;
          cursor:pointer;
          backdrop-filter:blur(10px);
        }
        .fog-carouselBtn--left{ left:12px; }
        .fog-carouselBtn--right{ right:12px; }
        .fog-carouselBtn:hover{ background:rgba(0,0,0,.6); }

        .fog-carouselSlide{
          display:grid;
          grid-template-columns: 1.4fr 1fr;
          gap:0;
          min-height: 360px;
        }
        .section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
        @media (max-width: 992px){
          .fog-carouselSlide{ grid-template-columns: 1fr; }
          .fog-carouselBtn--left{ left:10px; }
          .fog-carouselBtn--right{ right:10px; }
        }

        .fog-carouselImageWrap{
          background:#000;
          width:100%;
          height:100%;
          min-height:360px;
        }
        .fog-carouselImage{
          width:100%;
          height:100%;
          object-fit:cover;
          display:block;
        }

        .fog-carouselCaption{
          padding:18px;
          display:flex;
          flex-direction:column;
          justify-content:center;
          gap:10px;
          background:rgba(0,0,0,.20);
        }
        .fog-carouselTitle{
          margin:0;
          font-weight:800;
          letter-spacing:.2px;
        }
        .fog-carouselSub{
          margin:0;
          opacity:.95;
          line-height:1.55;
        }
        .fog-carouselDots{
          margin-top:10px;
          display:flex;
          gap:8px;
          flex-wrap:wrap;
        }
        .fog-dot{
          width:10px;
          height:10px;
          border-radius:999px;
          border:1px solid rgba(255,255,255,.55);
          background:transparent;
          cursor:pointer;
          opacity:.85;
        }
        .fog-dot.is-active{
          background:#fff;
          opacity:1;
        }
        .section-title-body p {
          margin-bottom: 1.75rem;
        }
        .fog-mediaCarousel {
          margin-bottom: 3rem;
        }





        /* ===== Image Modal ===== */
        .fog-modalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.85);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fog-modalContent {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
}

.fog-modalContent img {
  max-width: 100%;
  max-height: 90vh;
  display: block;
}

.fog-modalClose {
  position: absolute;
  top: 10px;
  right: 14px;
  background: rgba(0,0,0,0.6);
  border: none;
  color: #fff;
  font-size: 28px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
}
.section-title-body p {
  margin-bottom: 1.75rem;
}

/* =========================
   MOBILE UI
   ========================= */
@media (max-width: 768px) {
  .block.color-scheme-4 {
    padding: 20px 0 28px !important;
  }

  .hra-topTitle {
    font-size: 28px !important;
    line-height: 1.2 !important;
    margin: 0 !important;
  }

  .hra-topTitle span {
    display: block;
  }

  .section-divider {
    margin: 12px auto 14px !important;
    gap: 10px !important;
  }

  .section-divider span {
    font-size: 16px !important;
  }

  .hra-topIntro {
    font-size: 14px !important;
    line-height: 1.5 !important;
    padding: 0 4px;
    margin-top: 6px !important;
  }

  .section-title-body p,
  .section-title-body .white {
    font-size: 14px !important;
    line-height: 1.6 !important;
  }

  .section-title-body p {
    margin-bottom: 1rem !important;
  }

  .section-title-body h3 {
    font-size: 17px !important;
    line-height: 1.3 !important;
    margin: 8px 0 10px !important;
  }

  .mt-4 {
    margin-top: 1.25rem !important;
  }

  .mt-3 {
    margin-top: 0.75rem !important;
  }

  .container {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .fog-mediaCarousel {
    margin-bottom: 1.5rem !important;
    border-radius: 14px !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow: hidden !important;
  }

  .fog-carouselSlide {
    grid-template-columns: 1fr !important;
    min-height: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .fog-carouselImageWrap {
    min-height: unset !important;
    height: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    aspect-ratio: 3 / 4;
    max-height: 400px;
    overflow: hidden !important;
  }

  .fog-carouselImage {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
    background: #111;
  }

  .fog-carouselCaption {
    padding: 14px 12px 16px !important;
    gap: 8px !important;
    background: rgba(0, 0, 0, 0.72) !important;
  }

  .fog-carouselTitle {
    font-size: 15px !important;
    line-height: 1.35 !important;
    color: #fff !important;
  }

  .fog-carouselSub {
    font-size: 13px !important;
    line-height: 1.45 !important;
    color: rgba(255, 255, 255, 0.92) !important;
  }

  .fog-carouselBtn {
    width: 36px !important;
    height: 36px !important;
    font-size: 22px !important;
    top: 28% !important;
  }

  .fog-carouselBtn--left {
    left: 8px !important;
  }

  .fog-carouselBtn--right {
    right: 8px !important;
  }

  .fog-carouselDots {
    margin-top: 8px !important;
    gap: 5px !important;
    max-height: 28px;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap !important;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 2px;
  }

  .fog-dot {
    width: 8px !important;
    height: 8px !important;
    min-width: 8px !important;
    min-height: 8px !important;
    flex: 0 0 8px !important;
    padding: 0 !important;
    border-radius: 50% !important;
  }

  .media-carousel-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    overflow: hidden !important;
  }

  .fog-btn,
  .fog-btn--small {
    width: auto !important;
    min-width: 110px;
    padding: 10px 20px !important;
    font-size: 13px !important;
    border-radius: 40px !important;
  }

  .fog-action-buttons {
    gap: 0.75rem !important;
    margin-top: 1.25rem !important;
  }

  .fog-modalContent {
    max-width: 96vw !important;
    max-height: 88vh !important;
    border-radius: 10px !important;
  }

  .fog-modalContent img {
    max-height: 82vh !important;
    width: 100%;
    object-fit: contain;
  }

  .fog-modalClose {
    top: 6px !important;
    right: 8px !important;
    width: 36px !important;
    height: 36px !important;
    font-size: 24px !important;
  }

  .fog-videoControls {
    bottom: 6px !important;
    left: 6px !important;
    gap: 4px !important;
  }

  .fog-ctrlBtn {
    font-size: 8px !important;
    line-height: 1.1 !important;
    min-width: 42px !important;
    height: 22px !important;
    padding: 0 6px !important;
    border-radius: 6px !important;
    font-weight: 700 !important;
    letter-spacing: 0 !important;
    background: rgba(10, 14, 22, 0.74) !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.28) !important;
  }
}

@media (max-width: 480px) {
  .hra-topTitle {
    font-size: 24px !important;
  }

  .fog-carouselImageWrap {
    aspect-ratio: 4 / 5;
    max-height: 360px;
  }

  .fog-carouselTitle {
    font-size: 14px !important;
  }
}

      `}</style>

      <section>
        <div className="block color-scheme-4">
          {/* ===== Heading ===== */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <h1 className="head-title hra-topTitle white">
                  <span>MEDIA</span>
                  <div className="section-divider">
    <span>✦ ✦ ✦</span>
  </div>
                </h1>
                <p className="hra-topIntro white">
                  The official hub for press coverage, proclamations, recognitions, and media inquiries related
                  to Americans4Hindus(A4H) and Festival of Globe(FOG).
                </p>
              </div>
            </div>
          </div>

          {/* ===== Full-width video ===== */}
          {/* <div className="fog-fullVideo">
            <video
              ref={topVideoRef}
              src={Rajneeti1}
              playsInline
              muted={isMuted}
              autoPlay
              loop
              preload="metadata"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />
            <div className="fog-videoControls">
              <button type="button" className="fog-ctrlBtn" onClick={togglePlayPause}>
                {isPlaying ? "Pause ⏸️" : "Play ▶️"}
              </button>
              <button type="button" className="fog-ctrlBtn" onClick={toggleMute}>
                {isMuted ? "Unmute 🔊" : "Mute 🔇"}
              </button>
            </div>
          </div> */}

          {/* ===== Content ===== */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <article className="section-title-body white">
                  <div className="mt-4">
                    <p className="white">
                      The Media page serves as the official hub for all press coverage, proclamations, and media
                      inquiries related to the Americans4Hindus. It showcases the organization’s impact, leadership,
                      and national visibility while providing accessible resources for journalists, partners, and the
                      public.
                    </p>
                  </div>

                  {/* 1. Press Releases */}
                  <div className="mt-4">
                    <h3 className="white">1. A4H Press Releases</h3>
                    <p className="white">
                      Stay informed with the latest official announcements, news coverage, and media statements
                      from Americans4Hindus. This section highlights A4H milestones, upcoming events, community
                      initiatives, and collaborative projects.
                    </p>

                    {/* ✅ moving slideshow for featured press releases (PDF covers as images) */}
                    <div className="media-carousel-wrapper">
                      <MediaCarousel items={pressReleases} ariaLabel="Press Releases slideshow" />
                    </div>



                  </div>

                  {/* 2. Proclamations & Recognitions */}
                  <div className="mt-4">
                    <h3 className="white">2. FOG Proclamations &amp; Recognitions</h3>
                    <p className="white">
                      Festival of Globe has received numerous proclamations, commendations, and official recognitions
                      from cities, counties, and government leaders across the United States. This section celebrates
                      these honors and the civic impact of FOG’s work.
                    </p>

                    {/* ✅ moving slideshow for proclamations (JPG images) */}
                    <MediaCarousel items={proclamations} ariaLabel="Proclamations & Recognitions slideshow" />
                  </div>

                  {/* 3. Contact Us */}
                  <div className="mt-4">
                    <h3 className="white">3. Contact Us (Media Inquiries)</h3>
                    <p className="white">
                      For press inquiries, media partnerships, or additional information, the Festival of Globe Media
                      Team is available to assist. Connect with us to request interviews, high-resolution media assets,
                      or details about upcoming events and initiatives.
                    </p>

                    {/* Update these as you want */}
                    <ContactA4H></ContactA4H>
                  </div>

                  

                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FogMediaPage;
